import { render, staticRenderFns } from "./OrderDetailsShipping.vue?vue&type=template&id=9ff0d67a"
import script from "./OrderDetailsShipping.vue?vue&type=script&lang=js"
export * from "./OrderDetailsShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports